<template>
  <div>
    <template>
      <v-text-field :label="$t('message.campaigns.message.text')"
                    v-model="dataInteraction.descricao"
                    :counter="maxLength"
                    :maxlength="maxLength"
                    @change="(evt) => $emit('change', {descricao: evt})"></v-text-field>
    </template>

    <app-color-picker v-model="color"
                      :data-control-name="$t('message.campaigns.message.font')"
                      type="FONT"
                      :interaction="dataInteraction"
                      :data-show-checkbox="false"
                      :removeCheckboxDiv="noDisplayColorPickerCheckbox"></app-color-picker>
  </div>
</template>

<script>
    import AppColorPicker from './ColorPicker'
    import editor from '../mixins/editor'
    import _ from 'lodash'

    export default {
        components: {
            AppColorPicker,
        },

        data() {
            return {
                max: 60
            }
        },

        props: {
            noDisplayColorPickerCheckbox: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        computed: {
            style() {
                return this.dataInteraction.estilo
            },

            color: {
                get() {
                    return this.style.question.color
                },

                set(val) {
                    const style = _.cloneDeep(this.style)
                    style.question.color = val

                    const data = {
                        estilo: style
                    }

                    this.$store.commit('SET_INTERACTION_DATA', {
                        interactionId: this.dataInteraction.id,
                        data
                    })

                    this.setTimeout({
                        interaction: this.dataInteraction,
                        data
                    })
                }
            }
        },

        mixins: [editor]
    }
</script>

<style scoped>
</style>
